import axios from 'axios';

const isLive = true;
const apiUrl = isLive ? 'http://10.250.5.23:6699' : 'http://localhost:6699';

export const getData = async (url) => {
     try {
          const response = await axios.get(apiUrl + '' + url);
          return response;
     } catch (error) {
          throw error;
     }
};

export const getExternalData = async (url, body) => {
     try {
          const response = await axios.get(url, body);
          return response.data;
     } catch (error) {
          throw error;
     }
};

export const getDataWithBody = async (url, body) => {
     try {
          const response = await axios.get(apiUrl + '' + url, body);
          return response.data;
     } catch (error) {
          throw error;
     }
};

export const signin = async (data) => {
     try {
          const response = await axios.post(apiUrl + '/login', data);
          const token = response.data.token;
          const fullName = response.data.name;
          const userName = response.data.username;
          const isAdmin = response.data.isAdmin;
          sessionStorage.setItem('token', token);
          sessionStorage.setItem('fullName', fullName);
          sessionStorage.setItem('userName', userName);
          sessionStorage.setItem('isAdmin', isAdmin);
          const res = response.status;
          return res;
     } catch (error) {
          console.log('log in failed ' + error);
          throw error;
     }
};

export const postData = async (url, data) => {
     try {
          const response = await axios.post(apiUrl + url, data);
          return response.data;
     } catch (error) {
          throw error;
     }
};

export const putData = async (url, data) => {
     try {
          const response = await axios.put(url, data);
          return response.data;
     } catch (error) {
          throw error;
     }
};

export const deleteData = async (url) => {
     try {
          const response = await axios.delete(url);
          return response.data;
     } catch (error) {
          throw error;
     }
};
